import classNames from 'classnames';
import { useField } from 'formik';
import TimePickerControl from '../../controls/TimePickerControl';
import { DateTimeStamp } from '../../../types/primitives/DateTimeStamp';
import { FormError } from '../../controls/FormError';

interface TimeFieldProps {
    name: string;
    label: string;
    wrapperClassName?: string;
    required?: boolean;
    placeholder?: string;
}

export function TimeField({ name, label, wrapperClassName, required, placeholder = 'Select' }: TimeFieldProps) {
    const [field, meta, helpers] = useField<string | null | undefined>(name);

    const handleTimeChange = (time?: DateTimeStamp) => {
        helpers.setValue(time ?? null);
    };

    return (
        <div className={classNames('data-item-row', wrapperClassName)} onClick={e => e.stopPropagation()}>
            {label && (
                <label className="data-item-col data-item-col-title data-item-capitalize">
                    {label}
                    {required && <span className="text-red"> *</span>}
                </label>
            )}
            <div className="data-item-col">
                <TimePickerControl
                    minuteStep={15}
                    placeholder={placeholder}
                    time={field.value || null}
                    emptyEnabled
                    onTimeChange={handleTimeChange}
                />
                {meta.touched && meta.error && <FormError message={meta.error} />}
            </div>
        </div>
    );
}
